module.exports = __webpack_public_path__ + "img/VARIANT_BOX.dfb67570.svg";